import { Component, HostListener } from '@angular/core';
import { trigger, query, stagger, animate, style, transition } from '@angular/animations'
import { AnalyticsService } from '../../../shared';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  animations:[
    trigger("animateFooter", [
      transition(":enter", [
        query("*", [
          style({opacity: 0, transform: "translateY(100%)"}),
          stagger(50, [
            animate(
              "1000ms cubic-bezier(0.35, 0, 0.25, 1)",
              style({opacity:1, transform: "none"})
            )
          ])
        ])
      ])
    ])
  ]
})
export class FooterComponent {

  currentYear: number = new Date().getFullYear();

  constructor(public analyticsService: AnalyticsService) { }

}
